import { render, staticRenderFns } from "./surveyForm.vue?vue&type=template&id=60fc5686"
import script from "./surveyForm.vue?vue&type=script&lang=js"
export * from "./surveyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports